import {
  GSButton,
  GSInfoGroup,
  defaultGapping,
} from "golfstatus_react_components";
import {
  faClock,
  faPaperPlane,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { getV3DateTime } from "../../../helpers/Dates";
import { getMessageCountLines } from "../../../forms/MessageForms";

const STATUS_INFO = {
  scheduled: { label: "SCHEDULED", icon: faClock, color: "black" },
  sent: { label: "SENT", icon: faPaperPlane, color: "green" },
  draft: { label: "DRAFT", icon: faPen, color: "light-grey" },
};

const getStatusPrefix = (status) => {
  switch (status) {
    case "sent":
      return "Sent";
    case "scheduled":
      return "Scheduled";
    default:
      return "Created";
  }
};

const getTypeLabel = (channel) => {
  if (channel === "email") return "Email";
  if (channel) return "App Notification";
  return "";
};

const TournamentMessageInfo = (props) => {
  const {
    currentMessage,
    displayStatus,
    recipientCount = 0,
    isLocked,
    onComposeMessage,
    onDeleteMessage,
  } = props;

  const subject = currentMessage?.subject || "No Subject";
  const channel = currentMessage?.channel;
  const hasContent = !!(
    currentMessage?.subject ||
    currentMessage?.bodyHtml ||
    currentMessage?.bodyText
  );
  const date = currentMessage?.sentAt || currentMessage?.scheduledFor;
  const sender = currentMessage?.sender;

  const senderName = `${sender?.firstName ?? ""} ${sender?.lastName ?? ""}`
    .trim();

  const subjectItems = [
    {
      type: "headline-3 full-width",
      value: subject,
    },
  ];
  if (channel) {
    subjectItems.push({
      type: "secondary full-width",
      value: getTypeLabel(channel),
    });
    getMessageCountLines({
      status: displayStatus,
      uniqueSelectedCount: recipientCount,
      tournamentsCount: currentMessage?.tournamentsCount,
      selectedGroupsCount: currentMessage?.selectedGroupsCount,
    }).forEach((value) => {
      subjectItems.push({ type: "secondary full-width", value });
    });
  }

  const dateItems = [];
  if (date) {
    dateItems.push({
      type: "secondary full-width",
      value: getV3DateTime(date),
    });
  }
  if (senderName) {
    dateItems.push({
      type: "secondary full-width",
      value: `${getStatusPrefix(displayStatus)} by ${senderName}`,
    });
  }

  const statusInfo = STATUS_INFO[displayStatus];
  const badgeItems = [];
  if (statusInfo) {
    badgeItems.push({
      type: "primary no-wrap",
      value: (
        <GSButton
          title={statusInfo.label}
          buttonIcon={statusInfo.icon}
          type={`secondary status pill ${statusInfo.color}`}
        />
      ),
    });
  }
  const infoGroup = {
    fit: "stretch",
    sections: [
      { sectionItems: subjectItems },
      ...(dateItems.length > 0 ? [{ sectionItems: dateItems }] : []),
      ...(badgeItems.length > 0
        ? [
            {
              gap: "medium-gap",
              sectionItems: [
                {
                  type: "primary full-width",
                  value: (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        ...defaultGapping.mediumGap,
                      }}
                    >
                      {badgeItems.map((b, i) => (
                        <span key={i}>{b.value}</span>
                      ))}
                    </div>
                  ),
                },
              ],
            },
          ]
        : []),
    ],
  };

  const actionGroup = !isLocked && {
    sections: [
      {
        sectionItems: [
          {
            type: "primary no-wrap",
            value: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  ...defaultGapping.mediumGap,
                }}
              >
                {!hasContent && (
                  <GSButton
                    title="Compose Message"
                    buttonIcon={faPen}
                    type="black mobile-icon"
                    onClick={onComposeMessage}
                  />
                )}
                <GSButton
                  buttonIcon={faTrash}
                  type="light-grey"
                  onClick={onDeleteMessage}
                />
              </div>
            ),
          },
        ],
      },
    ],
  };

  const dataGroups = [infoGroup];
  if (actionGroup) dataGroups.push(actionGroup);

  return (
    <tournament-message-info>
      <GSInfoGroup listType="mobile-vertical" dataGroups={dataGroups} />
    </tournament-message-info>
  );
};

export default TournamentMessageInfo;
